﻿function GetFormXml(container) {
    // This is an auto generated field to block script/programs to submit form automatically. 
    //console.log("Element Length:" + $(container).find($('input[id^="txtFaxInfo"]')).length);
    if ($(container).find($('input[id^="txtFaxInfo"]')).length > 0 && $(container).find($('input[id^="txtFaxInfo"]')).val() != '') return null;

    var _entityXml = [];
    var _tempXml = '';
    var _tempValue = '';
    var _tempLabel = '';
    var _isValidated = true;

    $(container).find('*[FormNode="true"]').each(function () {
        _tempValue = '';

        if ($(this).attr('type') == 'checkbox') {
            var _delimiter = '';
            try {
                if ($(container).find('input[type="checkbox"][name="' + $(this).attr('name') + '"]:checked').length > 1) _delimiter = ';';
            } catch (err) { }
            $(container).find('input[type="checkbox"][name="' + $(this).attr('name') + '"]:checked').each(function () {
                _tempValue = _tempValue + $(this).val() + _delimiter;
            });
        } else if ($(this).attr('type') == 'radio') {
            if ($(this).is(':checked')) {
                _tempValue = $(this).val();
            }
        } else if ($(this).attr('captcha')) {
            try {
                var _captcha = '';
                var $captcha = $(this).closest('.captcha').find('[captcha-value]');
                _captcha = '<CaptchaValidator ID="' + $captcha.attr('captcha-id') + '">' + $(this).val() + '</CaptchaValidator>';
                if (MD5($(this).val()).toLowerCase() != $captcha.attr('captcha-value').toLowerCase()) {
                    _isValidated = false;
                    alert($(this).attr('FormMessage'));
                    return false;
                }
                _entityXml["Captcha"] = _captcha;
            } catch (e) { _isValidated = false; alert(e); return false; }
        } else {
            _tempValue = $(this).val();
        }

        if (isNullOrEmpty(_tempValue)) {
            if ($(this).attr('Required') == 'true' || $(this).attr('Required') == 'required') {
                _isValidated = false;
                alert($(this).attr('FormMessage'));
                return false;
            }
        } else {
            if ($(this).attr('FormType') != '') {
                if ($(this).attr('FormType') == 'Email' && !isValidEmail(_tempValue)) {
                    _isValidated = false;
                    alert($(this).attr('FormMessage'));
                    return false;
                }
            }

            if (!isNullOrEmpty($(this).attr('MinLength'))) {
                if (parseInt($(this).attr('MinLength')) > _tempValue.length) {
                    _isValidated = false;
                    alert($(this).attr('FormMessage'));
                    return false;
                }
            }
        }

        if (isNullOrEmpty($(this).attr('Entity'))) return;
        if (isNullOrEmpty($(this).attr('Node'))) return;

        _tempXml = _entityXml[$(this).attr('Entity')];
        if (isNullOrEmpty(_tempXml)) _entityXml[$(this).attr('Entity')] = '';

        if ($(this).attr('Entity') === 'Lead') {
            if (!_entityXml[$(this).attr('Entity')].includes("<Gclid>")) {
                var currentUrl = window.location.href;
                console.log(currentUrl);
                var url = new URL(currentUrl);
                var params = new URLSearchParams(url.search);

                if (params.has("gclid")) {
                    _additionaltemp = params.get("gclid").trim();
                    //_tempLabel = ' label="GCLID" ';
                    _additionaltempXml = '<Gclid  label="Gclid">' + ($(this).attr('data-agora-type') != 'xml' ? '<![CDATA[' + _additionaltemp + ']]>' : _additionaltemp) + '</Gclid>';
                    _entityXml[$(this).attr('Entity')] += _additionaltempXml;
                }
            }
        }


        if (!isNullOrEmpty(_tempValue)) {
            _tempValue = _tempValue.trim();
            if (!isNullOrEmpty($(this).attr('label'))) _tempLabel = ' label="' + $(this).attr('label') + '" '; else _tempLabel = '';
            _tempXml = '<' + $(this).attr('Node') + _tempLabel + '>' + ($(this).attr('data-agora-type') != 'xml' ? '<![CDATA[' + _tempValue + ']]>' : _tempValue) + '</' + $(this).attr('Node') + '>';
            _entityXml[$(this).attr('Entity')] += _tempXml;
        }
        
    });

    if (!_isValidated) return null;

    // Object.keys is not available on IE10, so we need to explicitly declare the function  (By Jo)
    if (!Object.keys) {
        Object.keys = (function () {
            'use strict';
            var hasOwnProperty = Object.prototype.hasOwnProperty,
                hasDontEnumBug = !({ toString: null }).propertyIsEnumerable('toString'),
                dontEnums = [
                  'toString',
                  'toLocaleString',
                  'valueOf',
                  'hasOwnProperty',
                  'isPrototypeOf',
                  'propertyIsEnumerable',
                  'constructor'
                ],
                dontEnumsLength = dontEnums.length;

            return function (obj) {
                if (typeof obj !== 'object' && (typeof obj !== 'function' || obj === null)) {
                    throw new TypeError('Object.keys called on non-object');
                }

                var result = [], prop, i;

                for (prop in obj) {
                    if (hasOwnProperty.call(obj, prop)) {
                        result.push(prop);
                    }
                }

                if (hasDontEnumBug) {
                    for (i = 0; i < dontEnumsLength; i++) {
                        if (hasOwnProperty.call(obj, dontEnums[i])) {
                            result.push(dontEnums[i]);
                        }
                    }
                }
                return result;
            };
        }());
    }
    // end of Object.keys declaration for IE10

    

    var _formXml = '<d>';
    for (p = 0; p < Object.keys(_entityXml).length; p++) {
        _formXml += '<' + Object.keys(_entityXml)[p] + '>' + _entityXml[Object.keys(_entityXml)[p]] + '</' + Object.keys(_entityXml)[p] + '>';
    }
    _formXml += '</d>';

    return escape(_formXml);
}

function composeUrlQuery(options) {
    //console.log('Started ...');
    if (options == null)
        return '';
    var urlQuery = '';
    var _urlQueryTraverse = new Object();

    var $controls = $(options.select).add($(options.select).find('[urlidentifier]'));
    if (options.nonselect != undefined && options.nonselect != null)
        $controls = $($controls).not(options.nonselect);

    var $traversedControls = $();
    //console.log('Controls fetch started ...');
    $($controls).each(function () {
        var _queryData = _getQueryDataForField(this, $controls, $traversedControls);
        //console.log('QD:' + JSON.stringify(_queryData));
        _addToQueryObject(_queryData, _urlQueryTraverse);
    });
    //console.log('Controls fetch completed ...');
    urlQuery = _getUrlQueryFromQueryObject(_urlQueryTraverse);

    if (options.additional != undefined && options.additional != null)
        return options.additional(urlQuery);

    return urlQuery;

    function _addToQueryObject(queryData, urlQueryTraverse) {
        if (queryData == null) return;
        if (queryData instanceof Array) {
            for (var key in queryData) {
                _addQueryDataToQueryObject(queryData[key], urlQueryTraverse);
            }
        } else {
            _addQueryDataToQueryObject(queryData, urlQueryTraverse);
        }
    }

    function _addQueryDataToQueryObject(queryData, urlQueryTraverse) {
        if (queryData == null) return;
        if (urlQueryTraverse[queryData.UrlIdentifier] == null) {
            urlQueryTraverse[queryData.UrlIdentifier] = new Array();
        }
        urlQueryTraverse[queryData.UrlIdentifier].push(queryData);
    }

    function _getUrlQueryFromQueryObject(urlQueryTraverse) {
        var _urlquery = '';
        for (var key in urlQueryTraverse) {
            var _isValueOnly = (key.toLowerCase() == '{$value}');
            var _valueSeperator = _isValueOnly ? '/' : ';';
            var _valueString = '';
            var MinMaxObject = null;
            for (var subKey in urlQueryTraverse[key]) {
                if (urlQueryTraverse[key][subKey].Operation.toLowerCase() == 'min' || urlQueryTraverse[key][subKey].Operation.toLowerCase() == 'max') {
                    if (MinMaxObject == null) MinMaxObject = { Min: 0, Max: 0 };
                    if (urlQueryTraverse[key][subKey].Operation.toLowerCase() == 'min') MinMaxObject.Min = urlQueryTraverse[key][subKey].Value;
                    if (urlQueryTraverse[key][subKey].Operation.toLowerCase() == 'max') MinMaxObject.Max = urlQueryTraverse[key][subKey].Value;
                } else if (urlQueryTraverse[key][subKey].Operation.toLowerCase() == 'thes') {
                    _valueString = urlQueryTraverse[key][subKey].Value.toString().replace(/[^0-9A-z\\.]/g, ';');
                    //.replace(/;+/g, ';')
                } else {
                    _valueString += urlQueryTraverse[key][subKey].Value.toString() + (urlQueryTraverse[key].length > 1 && urlQueryTraverse[key].length - 1 > subKey ? _valueSeperator : '');
                }
            }
            if (MinMaxObject != null) {
                if (_isValueOnly)
                    _urlquery = '/' + MinMaxObject.Min + (MinMaxObject.Max != 0 ? ('-' + MinMaxObject.Max) : '') + _urlquery;
                else
                    _urlquery += '/' + key + '-' + MinMaxObject.Min + (MinMaxObject.Max != 0 ? ('-' + MinMaxObject.Max) : '');
            }
            else {
                if (_isValueOnly)
                    _urlquery = '/' + _valueString + _urlquery;
                else
                    _urlquery += '/' + key + '-' + _valueString;

            }
        }
        return _urlquery;
    }

    function _getQueryDataForOneSearch(sender, controls, traversedControls) {

        var _queryDataForOneSearch = new Array();
        $(sender).parent().find('[onesearchidentifier]').each(function () {
            var _queryData = _getQueryDataValueForField(this);
            if (_queryData != null)
                _queryDataForOneSearch.push(_queryData);
        });
        if (_queryDataForOneSearch.length == 0 || _checkOneSearchIsMultiSelect(sender))
            if (_isNotNullOrEmpty(sender)) {
                var _oneSearchTextSearch = _getQueryDataValueForField(sender);
                return _oneSearchTextSearch;
            }
        return _queryDataForOneSearch;
    }

    function _checkOneSearchIsMultiSelect(sender) {
        return sender != null && $(sender).attr('multiselectboxid') != undefined && $(sender).attr('multiselectboxid') != "";
    }

    function _getQueryDataForField(sender, controls, traversedControls) {
        if ($(sender).attr("onesearchname") != null) {
            return _getQueryDataForOneSearch(sender, controls, traversedControls);
        } else {
            try {
                if ($(traversedControls).find(sender).length > 0)
                    return null;
                traversedControls = traversedControls.add(sender);
                return _getQueryDataValueForField(sender);
            } catch (e) { console.log('Error For Field'); }
        }
        return null;
    }

    function _getQueryDataValueForField(sender) {
        try {
            if (!_isNotNullOrEmpty(sender))
                return null;
        } catch (e) {
            console.log('Error For Field Value Check:' + $(sender).attr("type"));
        }
        try {
            return { UrlIdentifier: ($(sender).attr('urlidentifier') != null ? $(sender).attr('urlidentifier') : $(sender).attr('onesearchidentifier')), Value: _getValue(sender), Operation: ($(sender).attr('operation') != null ? $(sender).attr('operation') : '') };
        } catch (e) {
            console.log('Error For Field Value:' + $(sender).prop("tagName"));
        }
        return null;
    }

    function _getValue(sender) {
        var _value = $(sender).val();
        var _isOneSearch = typeof ($(sender).attr('onesearchidentifier')) != 'undefined';
        if (typeof (_value) == 'object') {
            var _values = '';
            for (var key in _value) {
                if (_value[key] != '')
                    _values += (_values == '' ? '' : ';') + _value[key].replace(/\-/g, '_').replace(/\//g, '!').replace(/\,/g, '@').replace(/\&/, '$').replace(/\#/g, '%23');
            }
            return _values;
        } else {
            if ($(sender).attr('urlidentifier') != null && $(sender).attr("urlidentifier") == 'price') {
                return _value.replace(/\,/g, '').replace(/\-/g, '_').replace(/\//g, '!').replace(/\&/, '$').replace(/\@/g, '').replace(/\#/g, '%23');
            } else {
                if (_isOneSearch) {
                    return _value.replace(/\,/g, '@').replace(/\-/g, '_').replace(/\//g, '!').replace(/\&/, '$').replace(/\#/g, '%23');
                } else {
                    return _value.replace(/\-/g, '_').replace(/\//g, '!').replace(/\&/, '$').replace(/\#/g, '%23');
                }
            }
        }
    }

    function _replaceWhiteSpace(value) {
        return value.replace(/\s/g, '-');
    }


    function _isNotNullOrEmpty(sender) {
        if ($(sender).attr('type') != null && ($(sender).attr('type') == 'radio' || $(sender).attr('type') == 'checkbox')) {
            return sender != null && sender != undefined && $(sender).val().trim() != '' && $(sender)[0].checked;
        } else if (sender != null && sender != undefined && $(sender).is('select')) {
            var _value = $(sender).val();
            return typeof (_value) == 'object' ? _value != null && _value != '' : _value.trim() != '';
        } else
            return sender != null && sender != undefined && $(sender).val().trim() != '';
    }
}

function isValidEmail(value) {
    var email = document.getElementById('txtEmail');
    var filter = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;

    if (!filter.test(value)) {
        return false;
    }
    return true;
}

function isNullOrEmpty(value) {
    if (value == null || value == undefined || value == '') return true;
    if (typeof (value) == 'string' && value.trim() == '') return true;
    return false;
}

function isNotNullOrZero(Value) {
    return Value != null && Value != undefined && Value.length > 0;
}

function isNullOrEmptyControl(ctrl) {
    if (ctrl == null || ctrl == undefined) return false;
    if ($(ctrl).val() == null || $(ctrl).val() == undefined || $(ctrl).val() == '') return true;
    return false;
}

function OpenIWBPopup(url, queryString, within) {
    if (!isNullOrEmpty(queryString)) url += '?' + queryString;
    $('#PERFORM_IWB_ACTION_TRIGGER').attr('href', url);
    $('#PERFORM_IWB_ACTION_TRIGGER').trigger('click');

    if (isNullOrEmpty(within)) within = 1000;
    setTimeout(function () {
        $('#PERFORM_IWB_ACTION_TRIGGER').trigger('click');
    }, within);
}

function CloseIWBPopup() {
    $('#MODAL_ACCESS').foundation('reveal', 'close');
}

function OpenPopup(within) {
    if (isNullOrEmpty(within)) within = 1000;
    setTimeout(function () {
        $('#PERFORM_ACTION_TRIGGER').trigger('click');
    }, within);

}

function ClosePopup() {
    $('#MODAL_ACCESS').foundation('reveal', 'close');
}




function getFormattedPrice(price) {
    var label = "";
    if (price.toString().length > 0) {
        if (price.toString().length <= 6 && price.toString().length > 3) {
            label = price.toString().substring(0, price.toString().length - 3) + "K";
        } else if (price.toString().length > 6) {
            label = price.toString().substring(0, price.toString().length - 6) + "." + price.toString().substring(price.toString().length - 6, price.toString().length - 5) + "M";
        } else {
            label = price.toString();
        }
    } else {
        label = "N/A";
    }
    return "$" + label;
}

function isMultiLingual() {
    if ($("#MULTILINGUAL") != null && $("#MULTILINGUAL") != undefined && !isNullOrEmpty($("#MULTILINGUAL").val()) && $("#MULTILINGUAL").val() == "1") {
        return true;
    } else {
        return false;
    }
}

function getLocale() {
    if (isMultiLingual()) return $('#LOCALE').val(); else return "";
}

function InitDataSourceRelation(sctrl, pctrl, afterLoad) {
    var _source = $('#' + sctrl);

    for (var i = 0; i < pctrl.split(',').length; i++) {
        var _parent = $('#' + pctrl.split(',')[i]);

        $(_parent).change(function () {
            var _postData = '';
            _postData += 'Source=' + $(_source).attr('Source');
            _postData += '&AutoSort=' + $(_source).attr('AutoSort');
            _postData += '&DefaultItem=' + $(_source).attr('DefaultItem');

            if ($(_source).attr('Source') == "Xml") {
                _postData += '&XmlFileCode=' + $(_source).attr('XmlFileCode');
                _postData += '&XmlDataListKey=' + $(_source).attr('XmlDataListKey');
            }
            else if ($(_source).attr('Source') == "Database") {
                _postData += '&DataObjectName=' + $(_source).attr('DataObjectName');
                _postData += '&UrlIdentifier=' + $(_source).attr('UrlIdentifier');
                _postData += '&AdditionalWhere=' + $(_source).attr('AdditionalWhere');
            }

            var _parentValue = '';

            for (var j = 0; j < pctrl.split(',').length; j++) {
                var _parentInner = '#' + pctrl.split(',')[j];

                if (j > 0) _parentValue += ',';
                if ($(_parentInner).val() == '') {
                    _parentValue += $(_parentInner + ' input:checked').val();
                }
                else {
                    _parentValue += $(_parentInner).val();
                }
            }
            _parentValue = _parentValue.replace('undefined', '');
            _postData += '&ParentValue=' + _parentValue;

            $(_source).attr('disabled', 'disabled');
            $.ajax({
                type: 'POST',
                url: '/services/agoraRelationalDataSource.ashx',
                data: _postData,
                dataType: 'json',
                success: function (resultList) {
                    $(_source).get(0).options.length = 0;

                    $.each(resultList, function (index, item) {
                        $(_source).get(0).options[$(_source).get(0).options.length] = new Option(item.Value, item.Key);
                    });

                    $(_source).removeAttr('disabled');

                    if (afterLoad != null) afterLoad($(_source));
                },
                statusCode: {
                    404: function () {
                        alert('Service (agoraParentDataSource) not found!');
                    }
                }
            });
        });
    }
}


function enterFullScreen() {
    if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
    } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
    } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
    }
}

function exitFullScreen() {
    if (document.cancelFullScreen) {
        document.cancelFullScreen();
    } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
    } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
    }
}

function ShowLoading() {
    try {
        if ($("body").hasClass('is-busy'))
            $("body").removeClass('is-busy');
        else
            $("body").addClass('is-busy');
    } catch (e) { }
}

var _agoraMsgDelay = null;
function ShowAlert(message, delay, cssClass, type) {
    _showAlert(message, delay, cssClass, type, true);
}

function ShowAlert(message, delay, cssClass, type, enableAutoClose) {
    _showAlert(message, delay, cssClass, type, enableAutoClose);
}

function ShowAlert(message, delay, cssClass, type, enableAutoClose, enableOKButton) {
    _showAlert(message, delay, cssClass, type, enableAutoClose, enableOKButton);
}

function ShowAlert(message, delay, cssClass, type, enableAutoClose, enableOKButton, ActionUrl) {
    _showAlert(message, delay, cssClass, type, enableAutoClose, enableOKButton, ActionUrl);
}

function ShowAlert(message, delay, cssClass, type, enableAutoClose, enableOKButton, ActionUrl, DisableCloseButton) {
    _showAlert(message, delay, cssClass, type, enableAutoClose, enableOKButton, ActionUrl, DisableCloseButton);
}

function _showAlert(message, delay, cssClass, type, enableAutoClose, enableOKButton, ActionUrl, DisableCloseButton) {
    $('body').addClass('alert_box_loaded');
    var _msgBox = $('div#agoraAlertMessageBox');
    if (_msgBox == null || _msgBox.length < 1) {
        _msgBox = $('<div>')
                    .attr('id', 'agoraAlertMessageBox')
                    .addClass(cssClass)
                    .html('<div class="message-body"><span id="msg" class="msg"></span><div id="btn_ok"></div><div id="btn_close"></div></div>');
        $(_msgBox).prependTo('body');
    }
    $(_msgBox).attr('class', '');
    $(_msgBox).addClass(cssClass);
    $(_msgBox).show();
    $(_msgBox).find('span#msg').html(message);
    if (!DisableCloseButton) { $(_msgBox).find('div#btn_close').html('<a class="closeBtn right" href="javascript:void(0);" onclick="javascript:CloseAlert();"><i class="fa fa-times-circle"></i></a>'); }
    if (enableOKButton) {
        $(_msgBox).find('div#btn_ok').html('<a ' + (isNotNullOrZero(ActionUrl) ? 'href="' + ActionUrl + '"' : 'href="javascript:void(0);" onclick="javascript:CloseAlert();"') + '  title="Close" class="mdl-button mdl-button--primary mdl-button--raised mdl-js-button mdl-js-ripple-effect" style="align-content: right;">Ok</a>');
    }
    clearTimeout(_agoraMsgDelay);
    if (enableAutoClose) {
        if (delay == null) delay = 4000;
        _agoraMsgDelay = setTimeout(function () {
            CloseAlert();
        }, delay);
    }
}

function CloseAlert() {
    $('body').removeClass('alert_box_loaded');
    $('div#agoraAlertMessageBox').hide();
    try {
        if ($("body").hasClass('is-busy'))
            $("body").removeClass('is-busy');
    } catch (e) { }
}

function RecallCkeIFrame() {
    $('img.cke_iframe').each(function () {
        $(this).replaceWith(unescape($(this).attr('data-cke-realelement')));
    });
}

function EnableNearBySearch(ctrl, urlPrefix, urlSufix, radius, errlandingUrl) {
    $(ctrl).each(function () {
        $(this).click(function () {
            // Checking whether the browser have geolocation support
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(successHandler, errorHandler, { timeout: 20000 });
            } else {
                alert("Geolocation functionality not available");
            }
            function successHandler(position) {
                var _latitude = position.coords.latitude.toString().replace('-', '_');
                var _longitude = position.coords.longitude.toString().replace('-', '_');
                location.href = urlPrefix + "/rlat-" + _latitude + "/rlon-" + _longitude + "/rad-" + radius + urlSufix;
            }
            function errorHandler(err) {
                if (err.message.indexOf("Only secure origins are allowed") == 0) { alert("Your browser does not support this feature"); }
                else if (err.code == 1 /* PERMISSION_DENIED */) { alert("Permission denied to access geolocation"); }
                else if (err.code == 2 /* POSITION_UNAVAILABLE */) { alert("Your geolocation is not available"); }
                else if (err.code == 3 /* TIMEOUT */) { alert("Your geolocation is not available"); }
                else { alert("Your geolocation is not available"); }
                location.href = errlandingUrl;
            }
        });
    });
}

function BackToTop(sender) {
    var _navigatorPosition = $(sender).closest('[data-back-to-top-container]').offset();
    if (_navigatorPosition != null) {
        $('html,body').animate({ scrollTop: _navigatorPosition.top }, 700);
    } else {
        $('html,body').animate({ scrollTop: 0 }, 700);
    }
}

function TopToBottom(sender) {
    $('html,body').animate({ scrollTop: $(window).height() - $('#agora-layout-header').height() }, 700);
}

function EnableGoogleEventTracking() {
    $(document).on('click', '[data-ga-track]', null, function () {
        try {
            var _track = $(this).data('ga-track');
            GoogleAnalyticLogEvent(_track);
        } catch (e) { }
    });
}

function GoogleAnalyticLogEvent(track) {
    if (ga == null || typeof (ga) == 'undefined') return;
    var _param = track.split(',');
    switch (_param.length) {
        case 3:
            ga('send', 'event', _param[0], _param[1], _param[2]);
            break;
        case 2:
            ga('send', 'event', _param[0], _param[1]);
            break;
    }
}

function EnableStickyHeader(startPoint) {
    if (startPoint == null) startPoint = 0;

    (function (sender) {
        var _oldValue = 0;
        var $context = $(sender);
        $(window).on('scroll', _checkState);
        function _checkState() {
            var _newValue = $(window).scrollTop();
            if (_newValue > startPoint) $context.addClass('scroll'); else $context.removeClass('scroll').removeClass('scroll-down').removeClass('scroll-up');
            if (_oldValue > _newValue) $context.addClass('scroll-up').removeClass('scroll-down');
            if (_oldValue < _newValue) $context.addClass('scroll-down').removeClass('scroll-up');
            _oldValue = _newValue;
        };
        _checkState();
    })($('body'));
}

function CloseAgoraDropDownOnBodyClick() {
    $(document).on('reset', '.agora-dropdown', null, function () { try { var state = $(this).children('input').get(0); if (state.checked) state.checked = false; } catch (e) { } });
    $('body').on('click', function (e) {
        try {
            var $target = $(e.target);
            if ($target.is('input') || $(document).find($target).length==0) return;
            var $dropDowncontainer = $target.closest('.agora-dropdown');
            if ($dropDowncontainer.length == 0) {
                $('.agora-dropdown').trigger('reset');
            } else {
                if ($dropDowncontainer.hasClass('actions') && !$target.hasClass('agora-dropdown-handle') && $dropDowncontainer.children('input:checked').length > 0) {
                    $dropDowncontainer.trigger('reset');
                } else {
                    $('.agora-dropdown').not($dropDowncontainer).trigger('reset');
                }
            }
        } catch (ex) { }
    });
}


function MdlReloadControlState(item, parent, noAction) {
    if (noAction == null || noAction == undefined) {
        noAction = false;
    }
    $this = item;
    $parent = parent;
    var $partner = $("#" + $parent.attr("data-search-partner"));
    var $valueBind = $('#' + $parent.attr("data-search-value-bind"));
    var $searchView = $('#' + $parent.attr("data-search-view"));
    switch ($parent.attr("data-search")) {
        case "SelectBox":
            try {
                $parent.parent().find('[data-search-enable-for]').each(function () {
                    $(this).addClass('mdl-cell--hide');
                    $(this).find('input:checkbox').each(function () {
                        if (!noAction) {
                            $(this).removeAttr('checked');
                            if ($(this).closest('.mdl-js-checkbox').length > 0) $(this).closest('.mdl-js-checkbox')[0].MaterialCheckbox.uncheck();
                        }
                    });
                    $(this).find('select option').each(function () {
                        $(this).removeAttr('selected');
                        $(this).closest('.mdl-js-selectfield')[0].MaterialSelectfield.mdlDowngrade_();
                    });
                });
            } catch (err) { console.log(err.message); }
            $('[data-search-enable-for="' + $parent.val() + '"]').removeClass('mdl-cell--hide');
            $searchView.html($parent.attr("data-search-name-label") + ' (' + $parent.parent().find('[data-search-enable-for="' + $parent.val() + '"]').find("input[type=checkbox]:checked").length + ')');
            break;
        case "group":
            var $groupParent = $this.closest('[data-search-group]');
            $searchView = $('#' + $groupParent.attr("data-search-view"));
            var _count = $groupParent.find('[data-search="group"] input[type=checkbox]:checked').length;
            var _readList = {};

            $groupParent.find('[data-search="group"] [data-type="dropdown"]').each(function () {
                var $_temp = $(this);
                if($_temp.val()!="" && typeof($_temp.data('default-item')!='undefined') && $_temp.val()!=$_temp.data('default-item'))
                {
                    _count++;
                }
            });

            $groupParent.find('[data-search="group"] input[type=text]').each(function () {
                var $_temp = $(this);
                var _key = $_temp.attr('urlidentifier');
                if (isNotNullOrZero($_temp.val()) && typeof (_readList[_key]) == 'undefined')
                    _readList[_key] = _count++;
            });
            $searchView.html($groupParent.attr("data-search-name-label") + ' (' + _count + ')');
            break;
        case "checkList":
            try {
                if ($parent.attr('data-search-child') != null && $parent.attr('data-search-child') == "true" && $parent.parents().find('[data-search-parent="true"]').length > 0) {
                    $searchView.html($parent.attr("data-search-name-label") + ' (' + $parent.parent().find("input[type=checkbox]:checked").length + ')');
                } else {
                    $searchView.html($parent.attr("data-search-name-label") + ' (' + $parent.find("input[type=checkbox]:checked").length + ')');
                }
            } catch (err) {
                console.log(err.message);
                $searchView.html($parent.attr("data-search-name-label") + ' (' + $parent.find("input[type=checkbox]:checked").length + ')');
            }
            break;
        case "singleItem":
            if ($this.length > 0) {
                $parent.children().removeClass("select");
                try {
                    var _labelPosition = $parent.attr('data-search-name-label-position');
                    var _selectOption = typeof ($parent.attr('data-select')) != undefined && $parent.attr('data-select') != null && $parent.attr('data-select') != '' ? $parent.attr('data-select') : '';
                    if (typeof _labelPosition !== typeof undefined && _labelPosition !== false && _labelPosition == 'left') {
                        if (_selectOption == 'label') {
                            $searchView.html($parent.attr("data-search-name-label") + $this.attr("label"));
                            $searchView.attr('data-selected-value', $this.attr("value"));
                        }
                        else
                            $searchView.html($parent.attr("data-search-name-label") + $this.attr("value"));
                    }
                    else {
                        if (_selectOption == 'label') {
                            $searchView.html($this.attr("label") + $parent.attr("data-search-name-label"));
                            $searchView.attr('data-selected-value', $this.attr("value"));
                        }
                        else
                            $searchView.html($this.attr("value") + $parent.attr("data-search-name-label"));
                    }

                    try {
                        var _showCountOnly = $parent.attr('data-search-name-label-showCountOnly');
                        if (typeof (_showCountOnly) != 'undefined' && _showCountOnly != false) {
                            $searchView.html($parent.attr("data-search-name-label") + ' (' + $this.length + ')');
                        }
                    } catch (err) { console.log(err.message); }

                    try {
                        var _skipLabelAppendList = $parent.attr('data-search-name-label-skip-for').split(',');
                        for (i = 0; i < _skipLabelAppendList.length; ++i) {
                            if (typeof _skipLabelAppendList[i] != undefined && _skipLabelAppendList[i] != null && _skipLabelAppendList[i] == $this.attr("value")) {
                                $searchView.html($this.attr("value"));
                            }
                        }
                    } catch (err) { console.log(err.message); }
                }
                catch (err) {
                    $searchView.html($this.attr("value") + $parent.attr("data-search-name-label"));
                }
                $this.addClass("select");
                if (IsNotNull($this.attr("value"))) {
                    $valueBind.attr("value", $this.attr("value"));
                } else {
                    $valueBind.attr("value", "");
                }
            }
            break;
        case "oneSearch":
            $searchView.html($this.attr('data-search-name-label') + ' (' + ($('.multiselect-context .agora-onesearch-multi-sel-item-cont').length) + ')');
            break;
        case "range":
            $partner.removeClass("mdl-cell--hide");
            $parent.addClass("mdl-cell--hide");
            if ($this.length > 0) {
                if (IsNotNull($this.attr("value"))) {
                    $valueBind.val($this.attr("value"));
                } else {
                    $valueBind.val("");
                }
            }
            if ($valueBind.closest('.mdl-js-textfield').length > 0 && $valueBind.closest('.mdl-js-textfield').get(0).MaterialTextfield) $valueBind.closest('.mdl-js-textfield').get(0).MaterialTextfield.checkDirty();
            $searchView.html(BindRangeView($parent));
            break;
    }
}


//Search Controle
function BindRangeView(Parent) {
    var _minMax = new getMinMax(Parent);
    if (IsNotNull(_minMax.Min) && IsNotNull(_minMax.Max) && parseInt(_minMax.Min) > parseInt(_minMax.Max)) {
        alert("Minimum value should not exceed the maximum value");
        $('#' + Parent.attr("data-search-value-bind")).attr("value", "");
        $("#" + $('#' + Parent.attr("data-search-partner")).attr("data-search-value-bind")).attr("value", "");
        return Parent.attr("data-search-name-label");
    } else {
        switch ($("#" + Parent.attr("data-search-value-bind")).attr("operation")) {
            case "min":
                var _minValue = _minMax.Min;
                var $partner = $("#" + Parent.attr("data-search-partner"));

                if (typeof ($partner.data('is-init')) == 'undefined') {
                    $partner.data('init-value', $partner.html());
                    $partner.data('is-init', true);
                }

                if (IsNotNull(_minValue)) {
                    $partner.empty();
                    var _isSelect = $("#" + Parent.attr("data-search-partner")).is('select');
                    var tagName = _isSelect ? 'option' : 'li';
                    if (_isSelect) $partner.append('<option value=""></option>');
                    for (var i = 0; i < 5; ++i) {
                        switch (Parent.attr("data-search-type")) {
                            case "price":
                                var _rangeToIncrement = _getIncrementValue(_minValue, Parent);
                                _minValue = _getRoundOfValue(_minValue, _rangeToIncrement);
                                _minValue = (parseInt(_minValue) + _rangeToIncrement);
                                $partner.append('<' + tagName + ' value="' + _minValue + '" tabindex="22"><span>$' + _minValue.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,") + '</span></' + tagName + '>');
                                break;
                            case "year":
                                _minValue = (parseInt(_minValue) + 5);
                                $partner.append('<' + tagName + ' value="' + _minValue + '" tabindex="22"><span>' + _minValue + '</span></' + tagName + '>');
                                break;
                            default:
                                if (isNotNullOrZero(Parent.attr('data-default-increment')))
                                {
                                    _minValue = (parseInt(_minValue) + parseInt(Parent.attr('data-default-increment')));
                                    $partner.append('<' + tagName + ' value="' + _minValue + '" tabindex="22"><span>' + _minValue + '</span></' + tagName + '>');
                                }
                                break;
                        }
                    }
                    $partner.append('<' + tagName + ' value="0" tabindex="22"><span>Any</span></' + tagName + '>');
                }
                else {
                    if (typeof ($partner.data('is-init')) != 'undefined' && $partner.data('is-init') == true) {
                        $partner.html($partner.data('init-value'));
                    }
                }
                break;
            case "max":
                var _maxValue = _minMax.Max;
                var $partner = $("#" + Parent.attr("data-search-partner"));
                if (typeof ($partner.data('is-init')) == 'undefined') {
                    $partner.data('init-value', $partner.html());
                    $partner.data('is-init', true);
                }
                if (IsNotNull(_maxValue)) {
                    $partner.empty();
                    var _isSelect = $("#" + Parent.attr("data-search-partner")).is('select');
                    var tagName = _isSelect ? 'option' : 'li';
                    if (_isSelect) $partner.append('<option value=""></option>');
                    var _rangeToDecrement = _getDecrementValue(_maxValue, Parent);
                    _maxValue = _getRoundOfValue(_maxValue, _rangeToDecrement);
                    for (var i = 0; i < 5; ++i) {
                        switch (Parent.attr("data-search-type")) {
                            case "price":
                                _maxValue = (parseInt(_maxValue) - _rangeToDecrement);
                                if (_maxValue > 0) {
                                    $partner.prepend('<' + tagName + ' value="' + _maxValue + '" tabindex="22"><span>$' + _maxValue.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,") + '</span></' + tagName + '>');
                                }
                                break;
                            case "year":
                                _maxValue = (parseInt(_maxValue) - 5);
                                if (_maxValue > 0) {
                                    $partner.append('<' + tagName + ' value="' + _maxValue + '" tabindex="22"><span>' + _maxValue + '</span></' + tagName + '>');
                                }
                                break;
                            default:
                                if (isNotNullOrZero(Parent.attr('data-default-decrement'))) {
                                    var isSetMaxVal;
                                    if (isNullOrEmpty(isSetMaxVal))
                                    {
                                        _maxValue = _minMax.Max;
                                        isSetMaxVal = 'Yes';
                                    }
                                    _maxValue = (parseInt(_maxValue) - parseInt(Parent.attr('data-default-decrement')));
                                    if (_maxValue > 0) {
                                        $partner.prepend('<' + tagName + ' value="' + _maxValue + '" tabindex="22"><span>' + _maxValue + '</span></' + tagName + '>');
                                    }
                                }
                                break;
                        }
                    }
                    $partner.prepend('<' + tagName + ' value="0" tabindex="22"><span>Any</span></' + tagName + '>');
                }
                else {
                    if (typeof ($partner.data('is-init')) != 'undefined' && $partner.data('is-init') == true) {
                        $partner.html($partner.data('init-value'));
                    }
                }
                break;
        }
        switch (Parent.attr("data-search-type")) {
            case "price":
                if (IsNotNull(_minMax.Min) && IsNotNull(_minMax.Max)) {
                    return _formattoPrice(_minMax.Min) + "-" + _formattoPrice(_minMax.Max);
                } else if (IsNotNull(_minMax.Min) && !IsNotNull(_minMax.Max)) {
                    return _formattoPrice(_minMax.Min) + "+";
                } else if (!IsNotNull(_minMax.Min) && IsNotNull(_minMax.Max)) {
                    return "<" + _formattoPrice(_minMax.Max);
                } else {
                    return Parent.attr("data-search-name-label");
                }
                break;
            default:
                if (IsNotNull(_minMax.Min) && IsNotNull(_minMax.Max)) {
                    return _minMax.Min + "-" + _minMax.Max;
                } else if (IsNotNull(_minMax.Min) && !IsNotNull(_minMax.Max)) {
                    return _minMax.Min + "+";
                } else if (!IsNotNull(_minMax.Min) && IsNotNull(_minMax.Max)) {
                    return "<" + _minMax.Max;
                } else {
                    return Parent.attr("data-search-name-label");
                }
                break;
        }

        function _formattoPrice(num) {
            console.log('Formatt : ' + num);
            try {
                var _label = num;
                if (num == null || num == undefined || num == '') _label = '0';
                if (num >= 1000000) {
                    _label = '$' + (_label / 1000000).toFixed(2).replace(/\.?0+$/, "") + 'M';
                }
                else if (num >= 1000) {
                    _label = '$' + (_label / 1000).toFixed(2).replace(/\.?0+$/, "") + 'K';
                }
                else {
                    _label = '$' + _label.replace(/\.0+$/, "");
                }
                return _label;
            } catch (e) { }
            return '0';
        }

        function _getIncrementValue(value, parent) {
            try {
                var _stage = $(parent).data('stage');
                var _minValueText = $(parent).data('min-value');
                var _minValue = 1000000;
                var _stageValue = 100000;
                try {
                    if (!isNullOrEmpty(_stage))
                        _stageValue = parseInt(_stage, 10);
                    if (typeof (_minValue) != 'undefined' && _minValue != null && _minValue != '')
                        _minValue = parseInt(_minValueText, 10);

                } catch (e) { }
                return parseInt(value) < _minValue ? 25000 : (parseInt(value) < _minValue * 10 ? 50000 : _stageValue);
            } catch (e) { }
            return 100000;
        }

        function _getDecrementValue(value, parent) {
            try {
                var _stage = $(parent).data('stage');
                var _stageValue = 100000;
                try {
                    if (!isNullOrEmpty(_stage))
                        _stageValue = parseInt(_stage, 10);
                } catch (e) { }
                return parseInt(value) < 100000 ? 10000 : (parseInt(value) < 1000000 ? 50000 : _stageValue);
            } catch (e) { }
            return 100000;
        }

        function _getRoundOfValue(value, incrementalValue) {
            try {
                return (parseInt(value) - (parseInt(value) % incrementalValue)).toString();
            } catch (e) { }
            return value;
        }
    }
}

function getMinMax(Parent) {
    var _minValue = 0, _maxValue = 0;
    switch ($("#" + Parent.attr("data-search-value-bind")).attr("operation")) {
        case "min":
            _minValue = $("#" + Parent.attr("data-search-value-bind")).val();
            _maxValue = $("#" + $("#" + Parent.attr("data-search-partner")).attr("data-search-value-bind")).val();
            break;
        case "max":
            _minValue = $("#" + $("#" + Parent.attr("data-search-partner")).attr("data-search-value-bind")).val();
            _maxValue = $("#" + Parent.attr("data-search-value-bind")).val();
            break;
    }
    return { Min: _minValue, Max: _maxValue };
}


// Numeric only control handler
jQuery.fn.ForceNumericOnly =
function () {
    return this.each(function () {
        $(this).keydown(function (e) {
            var key = e.charCode || e.keyCode || 0;
            if (e.shiftKey) key=0
            // allow backspace, tab, delete, enter, arrows, numbers and keypad numbers ONLY
            // home, end, period, and numpad decimal
            return (
                key == 8 ||
                key == 9 ||
                key == 13 ||
                key == 46 ||
                key == 110 ||
                key == 190 ||
                (key >= 35 && key <= 40) ||
                (key >= 48 && key <= 57) ||
                (key >= 96 && key <= 105));
        });
    });
};

$("[data-numeric-only]").ForceNumericOnly();

$(document).ready(function () {
    $("[data-numeric-only]").ForceNumericOnly();
});

// Allow bookmark considering the page header with animate scroll
$(document).on('click', '[data-page-scroll]', _scrollForPageScroll);
$(document).on('tap', '[data-page-scroll]', _scrollForPageScroll);
function _scrollForPageScroll() {
    var $this = $(this);
    var $referencedItem = $('#' + $this.data('page-scroll'));
    var _itemPosition = $referencedItem != undefined && $referencedItem != null && $referencedItem.length > 0 ? $referencedItem.offset().top : 0;
    var _offset = 0;
    try {
        var _value = $this.data('page-scroll-offset');
        if (typeof (_value) != 'undefined' && _value != '') _offset = parseInt(_value);
        else _offset = $('#agora-layout-header').height();
    } catch (e) { }
    $("html, body").animate({ scrollTop: (_itemPosition - _offset) }, 1500);
    try {
        var $referencedTabItem = $('#' + $this.data('page-scroll-tab-id'));
        $referencedTabItem.trigger('click');
    } catch (e) { }
}



// Button to move top of the page
$(document).on('click', '[data-back-to-top]', function () {
    BackToTop(this);
});

$(document).on('tap', '[data-back-to-top]', function () {
    BackToTop(this);
});

// Button to move bottom of the page
$(document).on('click', '[data-back-to-down]', function () {
    TopToBottom(this);
});

$(document).on('tap', '[data-back-to-down]', function () {
    TopToBottom(this);
});


/* This code will allow to give a redirect url to a container
    data-href="<url>"
    target="_blank"
*/
$(document).on('click', '[data-href]', function (e) {
    if ($(e.target).closest('[data-non-click-content]').length > 0) return;
    if (!isNullOrEmpty($(this).data('href'))) {
        if (!isNullOrEmpty($(this).data('target'))) {
            window.open($(this).data('href'), $(this).data('target'));
        } else {
            location.href = $(this).data('href');
        }
    }
});

/*recurstion for fire event when class name is changed*/
function OnClassBehaviorChange(ctrl, handler) {
    if (!IsNullorEmpty($(ctrl).attr('oldClassName')) && $(ctrl).attr('oldClassName') != $(ctrl).attr('class')) handler();
    $(ctrl).attr('oldClassName', $(ctrl).attr('class'));
    setTimeout(function () { OnClassBehaviorChange(ctrl, handler); }, 100);
}

function AnimatePlaceholderText(ctrl, pht, idx) {
    var _pht = pht;
    if (idx == 0) {
        _pht = ctrl.attr('placeholder');
        ctrl.attr('placeholder', '');
    }
    if (idx == _pht.length) return;

    setTimeout(function () {
        ctrl.attr('placeholder', _pht.substr(0, ++idx)); 
        AnimatePlaceholderText(ctrl, _pht, idx);
    }, 150);
}


function AddReadMore(minLimit, lblMore, lblLess) {
    //This limit you can set after how much characters you want to show Read More.
    var carLmt = minLimit;
    // Text to show when text is collapsed
    var readMoreTxt = lblMore;
    // Text to show when text is expanded
    var readLessTxt = lblLess;


    //Traverse all selectors with this class and manupulate HTML part to show Read More
    $(".addReadMore").each(function () {
        if ($(this).find(".firstSec").length)
            return;

        var allstr = $(this).text();
        if (allstr.length > carLmt) {
            var firstSet = allstr.substring(0, carLmt);
            var secdHalf = allstr.substring(carLmt, allstr.length);
            var strtoadd = firstSet + "<span class='SecSec'>" + secdHalf + "</span><span class='readMore'  title='Click to Show More'>" + readMoreTxt + "</span><span class='readLess' title='Click to Show Less'>" + readLessTxt + "</span>";
            $(this).html(strtoadd);
        }

    });
    //Read More and Read Less Click Event binding
    $(document).on("click", ".readMore,.readLess", function () {
        $(this).closest(".addReadMore").toggleClass("showlesscontent showmorecontent");
    });
}
